import { render, staticRenderFns } from "./CampaignCard.vue?vue&type=template&id=256fda16&scoped=true&"
import script from "./CampaignCard.vue?vue&type=script&lang=ts&"
export * from "./CampaignCard.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignCard.vue?vue&type=style&index=0&id=256fda16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256fda16",
  null
  
)

export default component.exports